var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInputArrowUpside(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 10",
    height: 10,
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    transform: "matrix(-1 0 0 -1 20 10)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.231232 0.214343C0.53954 -0.0714069 1.03941 -0.0714069 1.34772 0.214343L10 8.23353L18.6523 0.214343C18.9606 -0.0714069 19.4605 -0.0714069 19.7688 0.214343C20.0771 0.500092 20.0771 0.963384 19.7688 1.24913L10.5582 9.78572C10.2499 10.0715 9.75007 10.0715 9.44176 9.78572L0.231232 1.24913C-0.0770772 0.963384 -0.0770772 0.500092 0.231232 0.214343Z",
    fill: "#383733"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputArrowUpside);
export default __webpack_public_path__ + "static/media/inputArrowUpside.d0c4a307b12ff098222cb930a1c4d3be.svg";
export { ForwardRef as ReactComponent };